import React from "react";
import {Route, Routes} from "react-router-dom";
import DiplomaTechcert from "./pages/DiplomaTechcert";
import DiplomaGra from "./pages/Diploma-gra";
import Consulta from "./pages/Consulta";
import {SendInfoConsulta} from "./api/send-info-consulta";
import DiplomaPos from "./pages/Diploma-pos";
import DiplomaMes from "./pages/Diploma-mes";
import CertificadoEvento from "./pages/CertificadoEvento";
import HistoricoVisualizar from "./pages/Historico-gra/Historico-visualizar";
import HistoricoTransferenciaVisualizar from "./pages/Historico-gra/Historico-transferencia-visualizar";

const Rotas = () => {
    return (
        <Routes>
            <Route element={<Consulta />} path="/"/>
            <Route element={<DiplomaGra consulta={new SendInfoConsulta()} />} path="/diploma"/>
            <Route element={<DiplomaTechcert />} path="/diploma-online/:token"/>
            <Route element={<DiplomaTechcert />} path="/historico-online/:token"/>
            <Route element={<DiplomaPos />} path="/diploma-pos-online/:token"/>
            <Route element={<DiplomaMes />} path="/diploma-mes-online/:token"/>
            <Route element={<DiplomaMes />} path="/historico-mes-online/:token"/>
            <Route element={<CertificadoEvento />} path="/certificado-evento/:token"/>
            <Route element={<HistoricoVisualizar/>} path="/historico-visualizacao/:token"/>
            <Route element={<HistoricoTransferenciaVisualizar/>} path="/historico-transferencia-visualizacao/:token"/>
            <Route element={<DiplomaTechcert />} path="/historico-parcial-online/:token"/>
            <Route element={<DiplomaTechcert />} path="/historico-transferencia-online/:token"/>

        </Routes>
    )
}

export default Rotas;
